// extracted by mini-css-extract-plugin
export default {"createBtn":"index_createBtn__JFrYq","btnContainer":"index_btnContainer__ukH6s","plusIcon":"index_plusIcon__TkE6B"};